import axiosPrivate from "../../../api/axiosPrivate";
import {
  ADD_CHART_OF_ACCOUNTS,
  CREATE_JOURNAL,
  DELETE_CHART_OF_ACCOUNT,
  GET_ACCOUNTS,
  GET_GL_ACCOUNTS,
  GET_RELATED_TRANSACTION,
  REVERSE_TRANSACTION,
  SEARCH_JOURNALS,
} from "../../../api/constant";
import {
  GET_GL_GROUPS,
  EDIT_ACCOUNT,
  GET_PAGINATED_ACCOUNTS,
} from "./../../../api/constant";

const getGlGroups = async (ID) => {
  const response = await axiosPrivate.get(`${GET_GL_GROUPS}/${ID}`);
  return response.data;
};

const getAccounts = async ({ search, pageNumber }) => {
  const response = await axiosPrivate.get(
    `${GET_PAGINATED_ACCOUNTS}?page=${pageNumber}&search=${search}`
  );
  return response.data;
};

const getAllAccounts = async () => {
  const response = await axiosPrivate.get(`${GET_ACCOUNTS}`);
  return response.data;
};

const getGlAccounts = async () => {
  const response = await axiosPrivate.get(`${GET_GL_ACCOUNTS}`);
  return response.data;
};

const createChartAccount = async (DATA) => {
  const response = await axiosPrivate.post(ADD_CHART_OF_ACCOUNTS, DATA);
  return response.data;
};

const editChartAccount = async (DATA) => {
  const response = await axiosPrivate.post(`${EDIT_ACCOUNT}/${DATA?.id}`, DATA);
  return response.data;
};

// get all transactions for a single post on a journal
const getRelatedTransactions = async (transaction_id) => {
  const response = await axiosPrivate.get(
    `${GET_RELATED_TRANSACTION}/${transaction_id}`
  );
  return response.data;
};

const createJournal = async (DATA) => {
  const response = await axiosPrivate.post(CREATE_JOURNAL, DATA);
  return response.data;
};

const filterJournals = async (DATA) => {
  const response = await axiosPrivate.post(SEARCH_JOURNALS, DATA);
  return response.data;
};

const getFiltered = async (DATA) => {
  const response = await axiosPrivate.post(
    `${SEARCH_JOURNALS}?page=${DATA?.pageNumber}`,
    DATA?.data
  );
  return response.data;
};

const reverseTransaction = async (DATA) => {
  const response = await axiosPrivate.post(REVERSE_TRANSACTION, DATA);
  return response.data;
};

const deleteChartOfAccount = async (id) => {
  const response = await axiosPrivate.get(`${DELETE_CHART_OF_ACCOUNT}/${id}`);
  return response.data;
};

const accountingService = {
  createChartAccount,
  getGlGroups,
  getAccounts,
  getAllAccounts,
  editChartAccount,
  createJournal,
  filterJournals,
  getFiltered,
  getRelatedTransactions,
  reverseTransaction,
  getGlAccounts,
  deleteChartOfAccount,
};

export default accountingService;
